export const motionAccessGranted = () => ({
  type: "ACCESS_GRANTED"
});
